import MessagingRoute from "./MessagingRoute";
import SearchRoute from "./components/Search/routes";
import Settings from "./components/Settings";
import ChatViewContainer from "./components/Settings/routes/ChatView/ChatViewContainer";
import BrowsePublicChannel from "./routes/BrowsePublicChannel";
import Forms from "./routes/Forms";
import FormTemplates from "./routes/FormTemplates";

export default [
  SearchRoute,
  BrowsePublicChannel,
  Forms,
  FormTemplates,
  Settings,
  ChatViewContainer,
  MessagingRoute,
];
